import { useState, useEffect } from 'react';
import weatherService from './weatherService';
import businessService from '../../services/businessService';

/**
 * Hook to fetch and manage weather data
 * Now fetches business location from profile API
 */
export const useWeather = (latitude = null, longitude = null) => {
  const [weather, setWeather] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    const fetchWeather = async () => {
      let lat = latitude;
      let lon = longitude;

      // If coords not provided, get from business profile
      if (!lat || !lon) {
        try {
          const response = await businessService.getProfile();
          const profile = response.data;
          
          if (profile.latitude && profile.longitude) {
            lat = profile.latitude;
            lon = profile.longitude;
          }
        } catch (e) {
          console.error('Error loading business location for weather:', e);
        }
      }

      // Fall back to default location (Mooresville, NC)
      if (!lat || !lon) {
        lat = 35.5851;
        lon = -80.8101;
      }

      const forecast = await weatherService.fetchForecast(lat, lon);
      
      if (mounted) {
        setWeather(forecast);
        setLoading(false);
      }
    };

    fetchWeather();

    return () => {
      mounted = false;
    };
  }, [latitude, longitude]);

  return { weather, loading };
};

/**
 * Hook to get weather for a specific date range (week view)
 */
export const useWeatherForDates = (dates) => {
  const { weather, loading } = useWeather();

  const weatherByDate = {};
  if (weather && dates) {
    dates.forEach(date => {
      const dayWeather = weatherService.getForDate(weather, date);
      if (dayWeather) {
        weatherByDate[date] = dayWeather;
      }
    });
  }

  return { weatherByDate, loading };
};

export default useWeather;